export default {
    /**
     * Get International recommendation text
     * @param score
     * @returns {string}
     */
    getRecommendation(score) {
        if (score > 66) {
            return 'Your applicant profile likely does not need international schools';
        }

        return 'You can consider applying to international schools';
    },
};
